import React from "react";
import { FiEdit2 } from "react-icons/fi";
import styles from "./ProfilePhotoAndName.module.css";

const ProfilePhotoAndName = ({ name = "Darshan", photoUrl }) => {
  const handleEditClick = () => {
    console.log("Edit icon clicked");
  };

  return (
    <div className={styles.profileContainer}>
      <img src={photoUrl} alt="Profile" className={styles.avatar} />
      <div className={styles.nameRow}>
        <span className={styles.nameText}>{name}</span>
        <FiEdit2 className={styles.editIcon} onClick={handleEditClick} />
      </div>
    </div>
  );
};

export default ProfilePhotoAndName;
